import { UserParticipant } from "./UserParticipant";

export class ActivityExecutorParticipant extends UserParticipant {
    activityDefId: string;
    activityDefName: string;
  }